import React from 'react';
import styled from 'styled-components';
import ShipperContracts from './component';

import { NavLink } from 'react-router-dom';

const StyledItem = styled(NavLink)`
  white-space: nowrap;
  font-weight: normal;
  height: 4.8rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--grey900);
  padding: 0 ${(props) => props.theme.base.gridSizes.S};
  border-bottom: 1px solid var(--grey100);
  &:hover {
    background: var(--grey100);
  }
`;

const ItemWrapper = ({ className, ...props }) => (
  <StyledItem {...props} activeClassName={className} />
);

const StyledMenuItem = styled(ItemWrapper)`
  && {
    background: var(--grey200);
  }
`;

export { StyledMenuItem };

export default styled(ShipperContracts)`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;

  .shippersList {
    width: 100%;
    max-width: 350px;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    ul li {
    }
  }

  .shipperContracts {
    overflow: hidden;
    overflow-y: auto;
    padding: 3.2rem;
    flex: 1;
  }

  .contractTable {
    border-collapse: collapse;
  }

  .contractLine {
    &:hover .contractLine__cell {
      background: var(--grey100);
    }

    &__cell {
      height: 3.2rem;
      text-align: left;
      vertical-align: middle;
      padding: 0 0.8rem;
      background: #fff;
      border: 1px solid var(--grey100);
    }

    &__head {
      height: 3.2rem;
      text-align: left;
      vertical-align: bottom;
      padding: 0 0.8rem;
      font-weight: normal;
      color: var(--grey700);
    }

    &__right {
      text-align: right;
    }

    &__inactive {
      opacity: 0.6;
    }

    &__center {
      text-align: center;
    }

    &__description {
      white-space: nowrap;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
